// ═══════════════════════════════════════════════════════════════
// QuickGiftModal.jsx
// Modal wrapper around GiftEntryForm.
// Triggered from the "Record Gift" button in DonorSidebarBlock
// or the sidebar action area.
// Path: src/components/features/QuickGiftModal.jsx
// ═══════════════════════════════════════════════════════════════

import React from "react";
import { X, Gift } from "lucide-react";
import { FONT_SIZES, FONT_FAMILY, ICON_SIZES } from "../../constants/appConfig";
import { GiftEntryForm } from "./GiftEntryForm";
import { useApp } from "../../context/AppContext";

export const QuickGiftModal = ({ member, onClose, onSaved }) => {
  const { palette, activeFunds, chapterSettings } = useApp();

  const memberName =
    `${member?.firstName || ""} ${member?.lastName || ""}`.trim() ||
    member?.credentialedFullName ||
    "Donor";

  const handleSaved = () => {
    onSaved?.();
    onClose();
  };

  return (
    // Backdrop
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      {/* Modal */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: palette.cardBg || "#ffffff",
          borderRadius: 14,
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          width: "100%",
          maxWidth: 560,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 20px",
            borderBottom: `1px solid ${palette.cardBorder}`,
            background: palette.accent1,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Gift size={ICON_SIZES.md} style={{ color: "#ffffff" }} />
            <div>
              <div
                style={{
                  fontSize: FONT_SIZES.md,
                  fontWeight: 700,
                  color: "#ffffff",
                  fontFamily: FONT_FAMILY,
                }}
              >
                Record Gift
              </div>
              <div
                style={{
                  fontSize: FONT_SIZES.xs,
                  color: "rgba(255,255,255,0.75)",
                }}
              >
                {memberName}
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: 8,
              border: "none",
              background: "rgba(255,255,255,0.2)",
              color: "#ffffff",
              cursor: "pointer",
              transition: "background 0.15s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,0.35)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
            }
          >
            <X size={ICON_SIZES.sm} />
          </button>
        </div>

        {/* Form body */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "20px",
          }}
        >
          <GiftEntryForm
            member={member}
            gift={null}
            onSaved={handleSaved}
            onCancel={onClose}
            palette={palette}
            activeFunds={activeFunds}
            chapterSettings={chapterSettings}
            showTypeSelector={true}
          />
        </div>
      </div>
    </div>
  );
};
